import { NavLink } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import {
  LayoutDashboard,
  Users,
  FolderKanban,
  Clock,
  Camera,
  BookOpen,
  MessageSquare,
  Calendar,
  BarChart2,
  FileText,
  Settings,
  Bell,
  LogOut,
  Activity,
  AlignLeft,
} from 'lucide-react';
import TrackFlowLogo from '../TrackFlowLogo';

const navItems = [
  { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard, roles: ['ADMIN', 'MANAGER', 'EMPLOYEE'] },
  { to: '/team', label: 'Team', icon: Users, roles: ['ADMIN', 'MANAGER'] },
  { to: '/projects', label: 'Projects', icon: FolderKanban, roles: ['ADMIN', 'MANAGER', 'EMPLOYEE'] },
  { to: '/timelogs', label: 'Time Logs', icon: Clock, roles: ['ADMIN', 'MANAGER', 'EMPLOYEE'] },
  { to: '/screenshots', label: 'Screenshots', icon: Camera, roles: ['ADMIN', 'MANAGER'] },
  { to: '/work-diary', label: 'Work Diary', icon: BookOpen, roles: ['ADMIN', 'MANAGER'] },
  { to: '/standups', label: 'Standups', icon: MessageSquare, roles: ['ADMIN', 'MANAGER'] },
  { to: '/meetings', label: 'Meetings', icon: Calendar, roles: ['ADMIN', 'MANAGER'] },
  { to: '/reports', label: 'Reports', icon: BarChart2, roles: ['ADMIN', 'MANAGER'] },
  { to: '/activity', label: 'Activity', icon: Activity, roles: ['ADMIN', 'MANAGER'] },
  { to: '/timeline', label: 'Timeline', icon: AlignLeft, roles: ['ADMIN', 'MANAGER'] },
  { to: '/invoices', label: 'Invoices', icon: FileText, roles: ['ADMIN'] },
  { to: '/email-preferences', label: 'Email Preferences', icon: Bell, roles: ['ADMIN', 'MANAGER', 'EMPLOYEE'] },
  { to: '/settings', label: 'Settings', icon: Settings, roles: ['ADMIN'] },
];

export default function Sidebar() {
  const { user, logout } = useAuth();

  const visibleItems = navItems.filter((item) =>
    item.roles.includes(user?.role || '')
  );

  return (
    <aside className="flex flex-col w-64 min-h-screen bg-gray-900 text-gray-100">
      {/* Logo */}
      <div className="flex items-center px-5 py-4 border-b border-gray-700">
        <TrackFlowLogo size="sm" showText />
      </div>

      {/* Nav */}
      <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
        {visibleItems.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-400 hover:bg-gray-800 hover:text-white'
              }`
            }
          >
            <Icon className="w-4 h-4 flex-shrink-0" />
            {label}
          </NavLink>
        ))}
      </nav>

      {/* User + Logout */}
      <div className="px-3 py-4 border-t border-gray-700">
        <div className="flex items-center gap-3 px-3 py-2 mb-2">
          <div className="flex items-center justify-center w-8 h-8 bg-blue-500 rounded-full text-white text-sm font-semibold flex-shrink-0">
            {user?.name?.charAt(0)?.toUpperCase() || 'U'}
          </div>
          <div className="overflow-hidden">
            <p className="text-sm font-medium text-white truncate">{user?.name || 'User'}</p>
            <p className="text-xs text-gray-400 truncate">{user?.role}</p>
          </div>
        </div>
        <button
          onClick={logout}
          className="flex items-center gap-3 w-full px-3 py-2 rounded-lg text-sm font-medium text-gray-400 hover:bg-gray-800 hover:text-white transition-colors"
        >
          <LogOut className="w-4 h-4 flex-shrink-0" />
          Sign out
        </button>
      </div>
    </aside>
  );
}
